@use "variables" as *;

.indentedText {
  margin-left: $spacing-xl;
}

.listItem {
  padding-left: $spacing-l !important;
}

.itemTitle {
  font-size: $fontSize-m;
  font-weight: bold;
}
